var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g2, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g3, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 966,
    height: 513,
    viewBox: "0 0 966 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6794 186.16L29.8914 199.591L31.0211 199.924L32.3237 191.85L27.6794 186.16Z",
    fill: "url(#paint0_radial_2825_32890)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.029 264.105L213.473 274.561C213.473 274.561 225.008 282.983 226.054 278.469C227.099 273.956 227.458 272.406 227.458 272.406L205.961 264.09L206.029 264.105Z",
    fill: "url(#paint1_radial_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.458 272.405C227.458 272.405 227.099 273.955 226.054 278.468C225.929 279.007 225.633 279.365 225.234 279.556C223.186 274.61 213.611 269.978 208.591 267.75L205.977 264.022L227.474 272.338L227.458 272.405Z",
    fill: "url(#paint2_radial_2825_32890)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.393 231.014L132.838 241.469C132.838 241.469 144.373 249.891 145.419 245.378C146.464 240.864 146.823 239.315 146.823 239.315L125.326 230.998L125.393 231.014Z",
    fill: "url(#paint3_radial_2825_32890)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M146.891 239.33C146.891 239.33 146.532 240.88 145.486 245.393C145.33 246.067 144.952 246.476 144.418 246.636C141.872 241.078 132.909 236.872 128.194 234.857L125.461 231.029L146.958 239.346L146.891 239.33Z",
    fill: "url(#paint4_radial_2825_32890)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M275.146 298.502L278.169 314.251L214.791 283.881L215.175 283.757L251.319 286.452L275.146 298.502Z",
    fill: "url(#paint5_radial_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M215.175 283.757L251.319 286.452L275.161 298.435L278.185 314.183L273.652 311.997C272.653 309.566 271.501 305.963 270.525 300.981C270.217 297.715 264.31 296.56 255.28 291.415C248.633 288.243 257.81 296.119 262.912 306.883L214.791 283.881L215.191 283.689L215.175 283.757Z",
    fill: "url(#paint6_radial_2825_32890)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.681 186.161L35.6027 177.704L37.0684 179.037L35.4971 186.126L35.6991 186.173L28.0269 187.731L27.681 186.161Z",
    fill: "url(#paint7_radial_2825_32890)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6992 186.171L278.793 278.478L279.157 300.496L251.321 286.452L250.849 286.343C253.186 280.851 257.029 278.05 257.029 278.05L241.406 273.792L236.204 277.555L227.572 274.065L29.0541 192.795L28.0944 187.746L35.7667 186.187L35.6992 186.171Z",
    fill: "url(#paint8_linear_2825_32890)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9895 189.675L29.292 187.171L35.0772 186.098C35.2119 186.129 35.3622 186.093 35.4969 186.124C36.1706 186.28 36.5692 187.011 36.3457 187.669C36.2365 188.141 35.8733 188.483 35.4223 188.591L35.3549 188.575L29.8704 189.576L29.9895 189.675Z",
    fill: "url(#paint9_linear_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6991 186.172L278.792 278.479L279.157 300.497L270.391 296.053C270.284 293.757 270.323 291.139 270.558 288.284C271.187 280.053 266.705 278.873 241.855 269.709C217.005 260.545 68.4016 201.273 38.7957 189.658C32.5471 187.217 29.5549 188.795 28.7236 191.158L28.1099 187.679L35.7822 186.121L35.6991 186.172Z",
    fill: "url(#paint10_linear_2825_32890)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M241.338 273.776L256.961 278.034C256.961 278.034 253.103 280.902 250.766 286.394L215.108 283.741L225.929 279.93L227.437 274.033L236.069 277.524L241.271 273.76L241.338 273.776Z",
    fill: "url(#paint11_radial_2825_32890)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3678 188.094C28.2118 188.768 28.5429 189.483 29.2165 189.639C29.8901 189.795 30.5538 189.381 30.7772 188.723C30.9333 188.05 30.5348 187.318 29.9286 187.178C29.255 187.022 28.5913 187.436 28.4353 188.11L28.3678 188.094Z",
    fill: "url(#paint12_radial_2825_32890)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2573 192.17L236.278 276.012L239.042 273.884L31.2573 192.17Z",
    fill: "#8B8B8B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3691 178.377L37.0682 179.036L35.4969 186.125L35.699 186.172L28.0268 187.731L27.975 187.648L36.3691 178.377Z",
    fill: "url(#paint13_radial_2825_32890)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M248.927 284.833L251.929 278.005L242.223 275.472L237.254 279.148L227.208 275.33L227.52 273.982L236.219 277.488L241.421 273.725L257.044 277.983C257.044 277.983 253.186 280.851 250.848 286.343L215.191 283.69L219.21 282.279L248.942 284.766L248.927 284.833Z",
    fill: "url(#paint14_radial_2825_32890)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M241.826 320.382C240.566 327.969 245.437 335.131 252.687 336.314C260.004 337.512 266.943 332.377 268.204 324.79C269.465 317.203 264.594 310.041 257.344 308.858C250.11 307.608 243.155 312.811 241.826 320.382Z",
    fill: "url(#paint15_radial_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M257.344 308.859C260.018 309.265 262.288 310.501 264.079 312.265C265.072 315.334 265.958 321.005 262.728 328.206C258.295 336.62 270.066 330.545 267.919 318.975C268.405 320.862 268.507 322.873 268.173 324.925C266.913 332.512 259.973 337.648 252.656 336.449C245.338 335.251 240.535 328.104 241.795 320.517C243.056 312.931 250.011 307.728 257.313 308.993L257.344 308.859Z",
    fill: "url(#paint16_radial_2825_32890)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M195.507 289.918C195.507 289.918 204.276 278.108 233.988 287.121C258.819 294.223 267.148 312.194 262.134 326.791C257.79 339.413 238.144 354.665 200.781 340.685C198.628 324.854 195.523 289.851 195.523 289.851L195.507 289.918Z",
    fill: "url(#paint17_radial_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M217.56 283.885C225.079 286.052 234.005 291.031 237.991 302.318C245.607 323.673 227.854 331.982 243.53 334.478C257.403 336.485 263.201 326.472 262.872 317.168C262.548 309.072 257.021 298.918 246.692 292.337C261.57 301.037 266.223 314.963 262.216 326.74C257.872 339.362 238.226 354.615 200.863 340.635C198.71 324.804 195.605 289.8 195.605 289.8C195.605 289.8 201.048 282.544 217.659 283.766L217.56 283.885Z",
    fill: "url(#paint18_radial_2825_32890)"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M183.376 309.184C180.714 324.964 190.648 339.687 205.469 342.198C220.373 344.657 234.579 333.894 237.293 318.197C239.955 302.417 230.089 287.709 215.2 285.183C200.296 282.723 186.09 293.487 183.376 309.184Z",
    fill: "url(#paint19_radial_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M188.088 308.146C186.004 320.511 194.038 332.097 206.066 334.103C218.094 336.109 229.473 327.743 231.541 315.445C233.61 303.148 225.591 291.495 213.63 289.504C201.602 287.498 190.224 295.864 188.088 308.146V308.146Z",
    fill: "#606060"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M193.246 306.715C194.632 298.589 200.09 292.188 207.136 289.348C209.262 289.06 211.392 289.057 213.579 289.421C225.607 291.427 233.641 303.013 231.49 315.362C230.104 323.488 224.646 329.89 217.6 332.729C215.474 333.018 213.277 333.005 211.09 332.641C199.062 330.635 191.028 319.049 193.112 306.684L193.246 306.715Z",
    fill: "url(#paint20_radial_2825_32890)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.712 332.086C223.712 332.086 215.822 339.485 203.247 334.939C190.672 330.393 188.046 322.119 186.971 318.179C185.896 314.239 182.051 331.448 200.652 339.094C217.19 345.836 227.859 331.343 223.728 332.018L223.712 332.086Z",
    fill: "#8D8D8D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M215.836 305.417C218.649 306.14 220.326 309.013 219.52 311.879C218.798 314.692 215.909 316.437 213.111 315.646C210.297 314.924 208.688 312.066 209.426 309.185C210.149 306.371 213.022 304.695 215.768 305.402L215.836 305.417ZM213.506 314.247C215.527 314.716 217.57 313.556 218.121 311.484C218.605 309.395 217.446 307.352 215.441 306.817C213.435 306.281 211.377 307.508 210.825 309.58C210.357 311.601 211.501 313.712 213.506 314.247Z",
    fill: "#606060"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M186.885 308.436C187.303 304.487 189.152 299.875 194.371 294.199C205.56 283.589 220.134 290.23 223.33 292.674C226.459 295.103 228.989 293.985 224.716 290.369C216.564 283.583 206.995 285.057 203.687 285.852C207.342 284.782 211.23 284.547 215.132 285.167C230.021 287.694 239.954 302.417 237.225 318.182C234.578 333.894 220.305 344.642 205.401 342.183C190.512 339.656 180.579 324.933 183.308 309.169C183.657 307.049 184.26 305.059 184.998 303.101C182.104 311.303 186.426 311.949 186.818 308.42L186.885 308.436Z",
    fill: "url(#paint21_radial_2825_32890)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M217.949 288.943C217.949 288.943 208.711 285.312 200.244 289.384C193.824 292.582 200.948 284.507 211.572 285.833C222.196 287.159 222.752 291.191 217.949 288.943Z",
    fill: "url(#paint22_radial_2825_32890)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M225.86 287.582C225.86 287.582 250.967 293.186 257.155 311.513C260.687 320.778 265.569 291.742 225.86 287.582Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6991 186.171L278.792 278.478L279.157 300.496L251.321 286.452L250.849 286.343C253.186 280.851 257.029 278.05 257.029 278.05L241.406 273.792L236.204 277.555L227.572 274.065L29.0539 192.795L28.0943 187.746L35.7666 186.187L35.6991 186.171Z",
    stroke: "#797979",
    strokeWidth: 0.08,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M291.078 250.873C308.821 231.275 328.971 221.818 368.971 230.234C408.988 238.582 506.087 262.497 506.087 262.497C506.424 262.575 506.76 262.653 507.129 262.596L507.232 262.762C507.232 262.762 547.647 271.841 558.671 283.694C559.8 284.949 561.007 285.868 562.245 286.652C563.472 287.788 564.855 289.173 566.409 290.739C575.072 299.916 570.59 310.376 558.549 323.132C546.524 335.82 536.038 342.476 536.038 342.476L530.463 346.934L475.926 336.003C469.958 332.349 458.758 325.85 446.53 321.029C428.307 313.897 422.65 322.382 408.908 336.66C397.044 348.96 387.425 360.147 368.982 356.726C366.961 356.257 364.955 355.722 362.95 355.186C362.883 355.171 362.815 355.155 362.748 355.139C349.487 351.712 336.512 348.28 324.599 345.166C248.907 325.358 273.486 270.434 291.177 250.754L291.078 250.873Z",
    fill: "url(#paint23_linear_2825_32890)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M274.627 281.133C276.298 278.823 285.855 266.983 305.892 273.329C327.987 280.293 333.508 302.725 319.764 318.848C312.169 327.735 299.469 329.549 287.13 327.045C272.049 313.401 270.628 296.249 274.694 281.149L274.627 281.133Z",
    fill: "url(#paint24_radial_2825_32890)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M363.729 263.588C363.729 263.588 353.127 260.635 336.492 257.065C319.858 253.495 320.614 254.522 310.432 250.673C300.251 246.823 300.935 246.627 297.823 249.952C294.694 253.344 293.62 255.225 290.761 258.679C288.572 261.082 290.412 260.799 292.541 261.718C294.723 262.72 306.262 266.529 310.376 267.766C314.423 268.988 337.457 274.041 341.199 275.049C344.955 275.991 352.146 280.496 357.975 281.988C363.789 283.548 371.696 286.8 370.922 282.787C370.148 278.775 363.744 263.521 363.744 263.521L363.729 263.588Z",
    fill: "url(#paint25_linear_2825_32890)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M408.743 336.765C422.485 322.488 428.142 314.003 446.364 321.135C458.592 325.955 469.808 332.386 475.76 336.108L452.632 331.459C452.632 331.459 447.404 329.822 445.121 338.45C442.823 347.145 444.148 342.342 442.823 347.145C441.58 351.897 442.944 357.04 455.05 358.709C467.223 360.393 480.998 362.52 480.998 362.52L483.508 367.005C482.983 368.658 478.31 378.72 443.427 373.336C422.791 370.187 395.555 363.664 368.764 356.748C387.208 360.169 396.827 348.982 408.691 336.682L408.743 336.765Z",
    fill: "url(#paint26_radial_2825_32890)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M362.783 355.291C362.783 355.291 362.648 355.26 362.581 355.244C362.581 355.244 362.716 355.275 362.783 355.291Z",
    stroke: "#4B4B4B",
    strokeWidth: 0.08,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M300.938 248.756L291.666 259.669L308.646 265.732L316.539 254.642L300.938 248.756Z",
    fill: "url(#paint27_linear_2825_32890)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M319.245 254.914L313.269 266.307L339.765 272.658L342.777 259.656L319.245 254.914Z",
    fill: "url(#paint28_linear_2825_32890)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M345.699 260.831C345.699 260.831 342.669 270.848 342.895 272.32C343.122 273.792 357.038 280.21 357.857 280.045C358.676 279.88 354.12 267.68 353.371 265.093C352.622 262.506 352.426 261.822 350.912 261.613C349.332 261.389 345.699 260.831 345.699 260.831Z",
    fill: "url(#paint29_linear_2825_32890)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M356.053 263.939L361.595 280.768L368.191 282.935C368.191 282.935 369.751 282.941 368.96 279.919C368.17 276.896 363.633 266.76 363.633 266.76C363.633 266.76 363.023 265.411 360.344 264.72C357.732 264.044 355.97 263.99 355.97 263.99L356.053 263.939Z",
    fill: "url(#paint30_linear_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M388.551 310.862C391.111 311.456 393.345 310.696 394.549 308.561C397.103 303.971 403.124 276.76 393.815 258.42C390.917 252.851 389.369 251.569 387.498 251.065C387.027 250.956 386.555 250.846 386.001 250.789C385.731 250.726 385.462 250.664 385.177 250.669C382.031 250.153 379.761 249.84 379.694 249.825L379.155 249.7L379.45 250.265C379.605 250.514 394.36 276.291 384.859 305.961C384.553 306.671 384.516 307.443 384.982 308.19C385.624 309.404 387.017 310.436 388.685 310.894L388.551 310.862ZM387.306 251.588C389.057 251.994 390.456 253.312 393.333 258.663C402.538 276.838 396.58 303.779 394.042 308.302C392.967 310.182 391.018 310.937 388.743 310.339C387.194 309.98 385.935 308.979 385.397 307.931C385.102 307.366 385.108 306.729 385.3 306.205C394.181 278.593 382.204 254.31 380.175 250.504C381.066 250.639 382.849 250.911 385.036 251.275C385.373 251.353 385.642 251.416 385.845 251.463C386.383 251.587 386.803 251.614 387.275 251.723L387.306 251.588Z",
    fill: "url(#paint31_linear_2825_32890)"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M394.615 280.397C394.816 281.367 395.417 282.145 395.951 281.984C396.469 281.892 396.739 281.031 396.554 279.995C396.352 279.026 395.819 278.263 395.285 278.423C394.767 278.516 394.497 279.376 394.682 280.413L394.615 280.397Z",
    stroke: "#4B4B4B",
    strokeWidth: 0.08,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.122 311.355C393.122 311.355 391.86 314.044 388.254 313.066C384.714 312.104 382.797 311.802 383.224 309.346C383.651 306.889 380.438 312.178 384.537 313.483C388.568 314.772 392.372 315.511 393.055 311.339L393.122 311.355Z",
    fill: "url(#paint32_linear_2825_32890)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.224 280.28C404.224 280.28 404.247 283.551 404.098 287.562C403.949 291.574 405.547 289.885 405.816 285.05C406.033 280.131 404.339 278.248 404.224 280.28Z",
    fill: "url(#paint33_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.799 281.057C408.799 281.057 408.89 284.343 408.741 288.354C408.592 292.366 410.19 290.677 410.474 285.775C410.691 280.856 408.998 278.973 408.882 281.005L408.799 281.057Z",
    fill: "url(#paint34_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.06 281.974C413.06 281.974 413.083 285.244 412.934 289.256C412.786 293.267 414.383 291.579 414.652 286.743C414.869 281.825 413.175 279.942 413.06 281.974Z",
    fill: "url(#paint35_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.17 282.926C417.17 282.926 417.177 286.264 417.044 290.208C416.896 294.219 418.509 292.464 418.778 287.628C419.062 282.725 417.301 280.827 417.185 282.858L417.17 282.926Z",
    fill: "url(#paint36_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.21 283.861C421.21 283.861 421.233 287.132 421.085 291.143C420.936 295.155 422.601 293.482 422.803 288.631C423.071 283.795 421.259 281.814 421.21 283.861Z",
    fill: "url(#paint37_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.471 284.777C425.471 284.777 425.478 288.115 425.345 292.059C425.197 296.071 426.862 294.398 427.063 289.547C427.264 284.696 425.519 282.73 425.471 284.777Z",
    fill: "url(#paint38_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.896 285.59C429.896 285.59 429.919 288.861 429.77 292.872C429.622 296.884 431.287 295.211 431.488 290.36C431.705 285.441 429.944 283.543 429.896 285.59Z",
    fill: "url(#paint39_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.954 286.46C433.954 286.46 433.962 289.798 433.829 293.742C433.68 297.753 435.345 296.081 435.562 291.162C435.763 286.311 434.086 284.361 433.97 286.392L433.954 286.46Z",
    fill: "url(#paint40_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.348 287.406C438.348 287.406 438.371 290.677 438.207 294.756C438.059 298.767 439.656 297.079 439.925 292.244C440.142 287.325 438.397 285.359 438.333 287.474L438.348 287.406Z",
    fill: "url(#paint41_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.442 288.426C442.442 288.426 442.465 291.696 442.317 295.708C442.168 299.72 443.833 298.047 444.035 293.196C444.251 288.277 442.491 286.379 442.442 288.426Z",
    fill: "url(#paint42_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.836 289.372C446.836 289.372 446.859 292.643 446.711 296.654C446.562 300.666 448.227 298.993 448.444 294.075C448.661 289.156 446.9 287.258 446.852 289.305L446.836 289.372Z",
    fill: "url(#paint43_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.106 289.936C451.106 289.936 451.129 293.207 450.98 297.218C450.832 301.23 452.429 299.541 452.698 294.706C452.899 289.855 451.154 287.889 451.106 289.936Z",
    fill: "url(#paint44_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.952 291.361C456.952 291.361 456.975 294.632 456.826 298.644C456.678 302.655 458.343 300.982 458.544 296.131C458.761 291.213 457 289.314 456.952 291.361Z",
    fill: "url(#paint45_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.371 293.062C463.371 293.062 463.394 296.332 463.246 300.344C463.097 304.355 464.763 302.683 464.979 297.764C465.196 292.846 463.435 290.947 463.387 292.994L463.371 293.062Z",
    fill: "url(#paint46_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.311 293.495C468.311 293.495 468.334 296.766 468.185 300.777C468.036 304.789 469.634 303.1 469.903 298.265C470.119 293.346 468.359 291.448 468.311 293.495Z",
    fill: "url(#paint47_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.794 294.676C472.794 294.676 472.817 297.946 472.668 301.958C472.52 305.969 474.185 304.297 474.386 299.445C474.587 294.594 472.842 292.628 472.794 294.676Z",
    fill: "url(#paint48_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.245 295.406C476.245 295.406 476.268 298.676 476.12 302.688C475.971 306.699 477.569 305.011 477.853 300.108C478.054 295.257 476.309 293.291 476.261 295.338L476.245 295.406Z",
    fill: "url(#paint49_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.535 296.187C480.535 296.187 480.558 299.457 480.41 303.469C480.261 307.48 481.942 305.74 482.143 300.889C482.36 295.971 480.599 294.072 480.551 296.119L480.535 296.187Z",
    fill: "url(#paint50_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.904 296.967C483.904 296.967 483.927 300.238 483.778 304.249C483.63 308.261 485.227 306.573 485.496 301.737C485.697 296.886 483.952 294.92 483.904 296.967Z",
    fill: "url(#paint51_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.029 297.852C488.029 297.852 488.052 301.122 487.904 305.134C487.755 309.145 489.42 307.473 489.621 302.622C489.838 297.703 488.078 295.804 488.029 297.852Z",
    fill: "url(#paint52_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.408 298.865C492.408 298.865 492.415 302.203 492.266 306.215C492.118 310.226 493.783 308.553 494 303.635C494.201 298.784 492.456 296.818 492.408 298.865V298.865Z",
    fill: "url(#paint53_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.549 299.682C496.549 299.682 496.572 302.953 496.423 306.965C496.275 310.976 497.873 309.288 498.141 304.452C498.358 299.534 496.597 297.635 496.549 299.682Z",
    fill: "url(#paint54_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.067 300.428C500.067 300.428 500.091 303.699 499.942 307.71C499.793 311.722 501.407 309.966 501.66 305.198C501.861 300.347 500.116 298.381 500.067 300.428Z",
    fill: "url(#paint55_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.103 301.665C505.103 301.665 505.121 304.65 504.968 308.377C504.83 312.036 506.329 310.466 506.571 306.051C506.762 301.552 505.172 299.835 505.103 301.665Z",
    fill: "url(#paint56_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.654 302.275C508.654 302.275 508.657 305.328 508.586 309.003C508.449 312.662 509.948 311.093 510.123 306.661C510.313 302.162 508.739 300.378 508.654 302.275Z",
    fill: "url(#paint57_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.592 303.045C512.592 303.045 512.61 306.03 512.539 309.705C512.401 313.364 513.901 311.795 514.076 307.364C514.266 302.865 512.676 301.148 512.592 303.045V303.045Z",
    fill: "url(#paint58_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.302 304.188C516.302 304.188 516.32 307.174 516.182 310.833C516.045 314.492 517.544 312.923 517.719 308.491C517.909 303.993 516.335 302.208 516.25 304.105L516.302 304.188Z",
    fill: "url(#paint59_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.484 304.855C519.484 304.855 519.487 307.908 519.365 311.5C519.227 315.159 520.726 313.59 520.968 309.174C521.159 304.675 519.584 302.891 519.5 304.788L519.484 304.855Z",
    fill: "url(#paint60_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.049 305.398C523.049 305.398 523.067 308.383 522.914 312.11C522.776 315.769 524.275 314.2 524.45 309.768C524.708 305.285 523.066 303.485 522.966 305.449L523.049 305.398Z",
    fill: "url(#paint61_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.905 306.218C526.905 306.218 526.908 309.271 526.77 312.93C526.632 316.589 528.131 315.02 528.306 310.589C528.564 306.106 526.922 304.306 526.838 306.203L526.905 306.218Z",
    fill: "url(#paint62_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.874 306.854C530.874 306.854 530.892 309.84 530.754 313.499C530.616 317.158 532.116 315.589 532.29 311.157C532.548 306.674 530.907 304.874 530.822 306.771L530.874 306.854Z",
    fill: "url(#paint63_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.109 307.604C534.109 307.604 534.127 310.59 533.989 314.249C533.851 317.908 535.351 316.339 535.525 311.907C535.783 307.424 534.142 305.624 534.057 307.521L534.109 307.604Z",
    fill: "url(#paint64_linear_2825_32890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.658 308.213C537.658 308.213 537.676 311.199 537.523 314.925C537.385 318.584 538.884 317.015 539.126 312.6C539.317 308.101 537.727 306.384 537.658 308.213Z",
    fill: "url(#paint65_linear_2825_32890)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M461.203 314.989C461.203 314.989 461.841 314.994 462.173 314.787C463.085 314.218 463.947 312.643 464.462 310.42C465.961 303.953 467.197 288.197 464.835 286.444C464.053 285.836 463.292 285.447 462.753 285.322C462.146 285.182 461.83 285.321 461.649 285.492C461.467 285.663 461.322 285.984 461.518 286.669C461.518 286.669 462.059 296.59 460.12 309.556C459.339 312.924 460.043 314.791 461.053 315.025L461.203 314.989ZM462.628 285.861C462.965 285.939 463.54 286.214 464.508 286.936C465.954 288.051 466.144 301.014 463.923 310.295C463.44 312.383 462.676 313.839 461.93 314.305C461.681 314.46 461.53 314.496 461.328 314.45C460.655 314.294 460.107 312.676 460.809 309.645C462.764 296.611 462.223 286.69 462.187 286.54C462.063 286.156 462.109 285.954 462.125 285.887C462.141 285.819 462.358 285.799 462.628 285.861V285.861Z",
    fill: "url(#paint66_linear_2825_32890)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M408.743 336.765C412.302 333.046 415.331 329.773 418.169 327.023C418.169 327.023 408.944 337.734 402.859 343.777C396.774 349.821 391.407 353.688 407.931 358.652C424.455 363.616 428.252 361.017 431.568 350.074C434.328 340.917 435.016 341.929 438.328 342.341C441.64 342.753 442.044 342.847 443.084 338.971C443.968 335.769 444.409 329.27 451.488 330.271C456.919 331.032 466.464 333.031 472.678 334.399C473.797 335.084 474.796 335.671 475.729 336.242L452.601 331.593C452.601 331.593 447.373 329.956 445.09 338.584C442.792 347.279 444.117 342.476 442.792 347.279C441.549 352.031 442.913 357.174 455.019 358.843C467.192 360.527 480.967 362.654 480.967 362.654L483.477 367.139C482.952 368.792 478.279 378.854 443.396 373.47C422.76 370.321 395.524 363.798 368.733 356.882C387.177 360.303 396.796 349.116 408.66 336.816L408.743 336.765Z",
    fill: "url(#paint67_radial_2825_32890)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M399.659 345.946C397.449 348.132 393.31 352.212 389.892 354.402C385.033 357.606 380.793 357.83 396.049 361.223C425.493 368.328 445.995 370.523 457.33 371.232C470.479 372.078 470.549 362.583 458.888 361.443C447.227 360.303 440.093 357.088 441.245 349.973C442.412 342.79 444.453 337.656 445.772 334.412C446.126 333.5 447.023 332.998 448.142 332.761C447.053 333.786 445.942 335.516 445.121 338.449C442.823 347.144 444.148 342.341 442.823 347.144C441.58 351.896 442.944 357.039 455.05 358.708C467.223 360.393 480.998 362.519 480.998 362.519L483.508 367.005C482.983 368.658 478.31 378.719 443.427 373.335C422.791 370.187 395.555 363.664 368.764 356.747C382.378 359.262 391.158 353.843 399.608 345.863L399.659 345.946Z",
    fill: "url(#paint68_radial_2825_32890)"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M507.164 262.748L507.061 262.582C514.156 262.594 527.231 246.6 536.53 228.524C546.331 209.501 585.387 135.287 588.69 128.386C591.992 121.485 593.071 120.812 598.683 122.325L604.295 123.839C604.295 123.839 556.464 270.55 554.229 277.13C553.713 280.276 556.366 281.388 562.146 286.773C560.908 285.989 559.716 285.003 558.572 283.815C547.615 271.978 507.133 262.883 507.133 262.883L507.164 262.748Z",
    fill: "url(#paint69_linear_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M511.944 260.803C537.36 268.749 545.257 271.431 558.358 236.633C572.743 198.441 593.316 142.73 597 131.73C599.313 124.813 595.126 123.275 591.752 123.132C593.381 121.309 595.143 121.362 598.682 122.324L604.294 123.837C604.294 123.837 556.463 270.549 554.229 277.129C553.713 280.275 556.366 281.386 562.146 286.771C560.907 285.988 559.716 285.002 558.572 283.814C547.615 271.977 507.132 262.882 507.132 262.882L507.029 262.716C508.439 262.759 510.087 262.076 511.913 260.937L511.944 260.803Z",
    fill: "url(#paint70_linear_2825_32890)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M509.917 261.894C549.358 275.787 552.496 273.888 564.048 238.731C576.544 202.87 597.674 138.629 602.694 123.395C604.31 123.77 604.31 123.77 604.31 123.77C604.31 123.77 556.479 270.481 554.245 277.061C553.729 280.207 556.382 281.319 562.162 286.704C560.924 285.92 559.732 284.934 558.588 283.746C547.631 271.909 507.149 262.814 507.149 262.814L507.045 262.648C507.9 262.633 508.87 262.432 509.901 261.961L509.917 261.894Z",
    fill: "url(#paint71_linear_2825_32890)"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M588.987 132.002C588.987 132.002 550.926 206.517 534.453 237.482C522.658 259.593 539.331 237.263 554.88 206.298C570.43 175.332 595.841 122.943 588.987 132.002V132.002Z",
    fill: "#8B8B8B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M405.668 344.216C405.668 344.216 412.813 334.514 420.351 327.104C427.888 319.693 435.742 317.964 445.068 321.828C452.435 324.954 449.648 323.812 441.999 322.82C429.81 321.203 422.595 326.914 405.652 344.283L405.668 344.216Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M912.545 419.909L908.832 428.276L907.62 427.996L908.11 418.527L912.545 419.909Z",
    fill: "url(#paint72_radial_2825_32890)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M767.613 399.322C767.613 399.322 766.813 402.473 765.445 407.764C764.093 412.987 759.378 410.972 755.173 406.449C750.968 401.925 747.309 395.967 747.309 395.967L767.613 399.322Z",
    fill: "url(#paint73_radial_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M748.929 398.472C747.915 397.03 747.309 395.967 747.309 395.967L767.613 399.322C767.613 399.322 766.953 401.867 765.804 406.214C761.386 401.997 754.184 399.689 748.929 398.472V398.472Z",
    fill: "url(#paint74_radial_2825_32890)"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M661.444 382.391C661.444 382.391 661.213 385.532 659.861 390.755C658.509 395.978 653.587 393.631 649.004 389.517C643.364 384.449 637.201 378.265 637.201 378.265L661.511 382.407L661.444 382.391Z",
    fill: "url(#paint75_radial_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M640.101 381.065C638.361 379.385 637.217 378.197 637.217 378.197L661.527 382.338C661.527 382.338 661.312 385.412 659.991 390.5C655.331 384.878 645.942 382.206 640.184 381.014L640.101 381.065Z",
    fill: "url(#paint76_radial_2825_32890)"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M539.93 366.731C542.044 367.718 544.235 369.29 546.579 368.058C548.907 366.894 549.654 365.506 552.83 367.732C556.005 369.958 559.65 368.318 560.23 363.058C560.679 358.974 557.234 357.608 555.684 357.249L565.784 359.305L563.773 366.15L584.616 369.63L587.27 374.717L584.311 385.957L573.844 377.214L568.794 385.84L561.771 385.207L531.157 383.154C532.622 378.666 534.898 371.599 535.698 369.371C536.95 366.112 537.681 365.713 539.811 366.632L539.93 366.731Z",
    fill: "url(#paint77_radial_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M531.276 383.252C532.741 378.765 535.017 371.697 535.818 369.469C537.069 366.21 537.801 365.812 539.93 366.731C542.044 367.718 544.235 369.29 546.579 368.058C548.907 366.894 549.654 365.506 552.83 367.732C556.005 369.958 559.65 368.318 560.23 363.058C560.679 358.974 557.234 357.608 555.684 357.249L565.784 359.305L563.773 366.15L584.616 369.63L587.27 374.717L586.802 376.738L582.743 371.894L562.615 368.082L557.701 374.894C557.701 374.894 563.969 378.476 567.887 385.772L561.771 385.207L531.157 383.154L531.276 383.252Z",
    fill: "url(#paint78_radial_2825_32890)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M584.743 384.708L584.446 385.988L573.911 377.23L568.861 385.855L568.089 385.818L573.401 373.918L584.743 384.708Z",
    fill: "url(#paint79_radial_2825_32890)"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M443.613 344.346C444.622 345.503 446.436 346.561 449.4 347.248C460.08 349.864 528.74 360.803 528.74 360.803L526.784 364.04C516.393 362.627 477.82 357.24 459.174 354.694C449.757 353.364 444.949 351.754 442.524 350.269C442.473 349.264 442.573 348.222 442.822 347.144C443.42 344.869 443.436 344.802 443.545 344.33L443.613 344.346Z",
    fill: "url(#paint80_radial_2825_32890)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M459.174 354.695C477.821 357.24 516.393 362.627 526.784 364.041L526.722 364.31C526.722 364.31 513.332 360.215 493.851 370.466L494.65 380.801L494.381 380.739L483.623 366.818C483.623 366.818 483.607 366.886 483.576 367.02L481.066 362.535C481.066 362.535 467.224 360.393 455.118 358.724C445.634 357.378 442.739 353.939 442.525 350.27C444.949 351.754 449.742 353.432 459.174 354.695ZM491.768 369.344L506.571 363.049L486.565 362.389L491.768 369.344V369.344Z",
    fill: "url(#paint81_radial_2825_32890)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M452.663 331.324L530.328 346.904L535.903 342.446L908.801 415.848L919.191 406.543L918.011 411.025L912.462 419.961L882.359 414.478L881.35 418.219L584.632 369.564L563.789 366.084L565.8 359.239L566.131 354.134L541.055 349.318L542.382 355.233L541.789 357.793C541.789 357.793 531.159 356.182 526.617 364.145L528.771 360.669C528.771 360.669 460.194 349.678 449.446 347.047C446.415 346.344 444.669 345.301 443.592 344.129C443.701 343.657 443.904 342.781 445.1 338.232C447.399 329.537 452.611 331.241 452.611 331.241L452.663 331.324Z",
    fill: "url(#paint82_linear_2825_32890)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M528.879 350.401C511.669 347.478 459.925 337.052 446.778 334.361C449.306 330.191 452.664 331.324 452.664 331.324L530.328 346.903L535.904 342.446L908.802 415.848C908.802 415.848 582.577 354.536 557.547 350.441C532.599 346.294 541.125 352.386 528.812 350.385L528.879 350.401Z",
    fill: "url(#paint83_linear_2825_32890)"
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M567.551 360.568L566.179 364.651L878.05 415.609L567.551 360.568Z",
    fill: "#8B8B8B"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M908.832 415.712L919.274 406.49L918.406 409.625L912.179 417.197L908.832 415.712Z",
    fill: "url(#paint84_linear_2825_32890)"
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M541.757 357.928L542.35 355.368L541.09 349.468L566.182 354.217L565.852 359.322L555.752 357.266C555.347 357.172 555.078 357.11 555.078 357.11L555.752 357.266C557.301 357.625 560.746 358.991 560.297 363.075C559.717 368.335 556.072 369.975 552.897 367.749C549.654 365.507 548.907 366.895 546.646 368.075C544.318 369.239 542.127 367.667 539.997 366.748C537.868 365.829 537.137 366.227 535.885 369.486C535.033 371.631 532.741 378.766 531.343 383.269L494.716 380.817L493.917 370.481C513.398 360.231 526.653 364.295 526.653 364.295C531.195 356.333 541.757 357.928 541.757 357.928V357.928Z",
    fill: "url(#paint85_radial_2825_32890)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M535.462 366.408C536.98 362.004 543.624 367.944 546.427 364.121C549.229 360.299 555.705 369.11 556.353 362.943C557.017 356.708 548.389 354.426 548.389 354.426L562.06 356.386L562.498 353.577L566.234 354.301L565.903 359.406L555.803 357.35C555.399 357.256 555.13 357.194 555.13 357.194L555.803 357.35C557.353 357.709 560.798 359.075 560.349 363.159C559.769 368.419 556.124 370.059 552.949 367.833C549.706 365.591 548.959 366.979 546.698 368.159C544.37 369.323 542.179 367.751 540.049 366.832C537.92 365.913 537.188 366.311 535.937 369.57C535.085 371.715 532.793 378.85 531.395 383.353L494.768 380.901L494.143 372.877C512.41 358.37 535.582 366.507 535.582 366.507L535.462 366.408Z",
    fill: "url(#paint86_radial_2825_32890)"
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M546.354 401.509C545.093 409.096 549.964 416.258 557.215 417.441C564.449 418.691 571.471 413.504 572.732 405.917C573.993 398.33 569.122 391.168 561.887 389.918C554.586 388.652 547.631 393.855 546.37 401.442L546.354 401.509Z",
    fill: "url(#paint87_radial_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M561.871 389.984C564.462 390.443 566.815 391.626 568.606 393.39C569.599 396.459 570.418 402.115 567.255 409.332C562.822 417.745 574.66 411.686 572.446 400.1C572.932 401.987 573.034 403.998 572.7 406.051C571.44 413.638 564.485 418.841 557.183 417.575C549.865 416.376 544.994 409.214 546.322 401.643C547.583 394.056 554.538 388.853 561.84 390.119L561.871 389.984Z",
    fill: "url(#paint88_radial_2825_32890)"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M500.033 371.045C500.033 371.045 508.803 359.235 538.514 368.248C563.278 375.334 571.675 393.321 566.66 407.918C562.316 420.54 542.67 435.792 505.307 421.812C503.154 405.982 500.033 371.045 500.033 371.045Z",
    fill: "url(#paint89_radial_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M522.02 364.996C529.538 367.164 538.464 372.142 542.451 383.429C550.067 404.784 532.313 413.093 547.974 415.657C561.847 417.664 567.645 407.65 567.249 398.331C566.924 390.235 561.398 380.081 551.068 373.501C565.946 382.2 570.599 396.126 566.593 407.903C562.249 420.525 542.603 435.778 505.24 421.798C503.087 405.967 499.966 371.031 499.966 371.031C499.966 371.031 505.409 363.774 522.02 364.996Z",
    fill: "url(#paint90_radial_2825_32890)"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M487.838 390.295C485.191 406.008 495.109 420.798 509.93 423.309C524.835 425.769 539.04 415.005 541.754 399.308C544.416 383.528 534.483 368.805 519.594 366.278C504.705 363.752 490.5 374.515 487.77 390.28L487.838 390.295Z",
    fill: "url(#paint91_radial_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M492.617 389.273C490.549 401.571 498.568 413.224 510.596 415.23C522.624 417.236 534.003 408.87 536.154 396.521C538.222 384.223 530.188 372.637 518.16 370.631C506.132 368.625 494.753 376.991 492.617 389.273Z",
    fill: "#606060"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M497.759 387.909C499.145 379.783 504.603 373.381 511.649 370.542C513.775 370.253 515.905 370.25 518.092 370.615C530.12 372.621 538.154 384.206 536.086 396.504C534.685 404.697 529.226 411.099 522.196 413.871C520.071 414.159 517.94 414.162 515.753 413.798C503.725 411.792 495.691 400.206 497.775 387.841L497.759 387.909Z",
    fill: "url(#paint92_radial_2825_32890)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M528.225 413.28C528.225 413.28 520.268 420.664 507.693 416.118C495.102 411.64 492.476 403.365 491.401 399.425C490.326 395.485 486.414 412.679 505.082 420.34C521.553 427.066 532.289 412.589 528.209 413.348L528.225 413.28Z",
    fill: "#8D8D8D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M520.296 386.53C523.126 387.185 524.72 390.11 523.981 392.991C523.258 395.805 520.385 397.482 517.639 396.774C514.825 396.051 513.149 393.179 513.954 390.313C514.677 387.499 517.55 385.823 520.364 386.545L520.296 386.53ZM517.967 395.36C519.988 395.828 522.031 394.669 522.582 392.596C523.05 390.575 521.907 388.464 519.901 387.929C517.896 387.393 515.837 388.62 515.286 390.693C514.802 392.781 515.961 394.824 517.967 395.36Z",
    fill: "#606060"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M491.362 389.48C491.78 385.53 493.629 380.919 498.848 375.243C510.053 364.565 524.627 371.207 527.807 373.718C530.936 376.147 533.466 375.029 529.193 371.413C521.025 364.694 511.405 366.085 508.097 366.88C511.752 365.811 515.639 365.576 519.609 366.211C534.513 368.671 544.364 383.445 541.769 399.241C539.123 414.954 524.85 425.702 509.945 423.242C495.057 420.716 485.123 405.993 487.853 390.228C488.202 388.108 488.805 386.119 489.542 384.16C486.648 392.362 490.97 393.009 491.362 389.48V389.48Z",
    fill: "url(#paint93_radial_2825_32890)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M522.411 370.054C522.411 370.054 513.172 366.424 504.705 370.495C498.286 373.693 505.409 365.619 516.033 366.944C526.641 368.337 527.213 372.303 522.411 370.054Z",
    fill: "url(#paint94_radial_2825_32890)"
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M530.386 368.708C530.386 368.708 555.442 374.229 561.682 392.639C565.198 401.972 570.028 372.852 530.386 368.708Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.244 277.194C311.244 277.194 292.948 264.864 276.262 279.595C270.649 285.748 329.21 287.887 311.244 277.194V277.194Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M291.078 250.873C308.821 231.275 328.971 221.818 368.971 230.234C408.988 238.582 506.087 262.497 506.087 262.497C506.424 262.575 506.76 262.653 507.129 262.596L507.232 262.762C507.232 262.762 547.647 271.841 558.671 283.694C559.8 284.949 561.007 285.868 562.245 286.652C563.472 287.788 564.855 289.173 566.409 290.739C575.072 299.916 570.59 310.376 558.549 323.132C546.524 335.82 536.038 342.476 536.038 342.476L530.463 346.934L475.926 336.003C469.958 332.349 458.758 325.85 446.53 321.029C428.307 313.897 422.65 322.382 408.908 336.66C397.044 348.96 387.425 360.147 368.982 356.726C366.961 356.257 364.955 355.722 362.95 355.186C362.883 355.171 362.815 355.155 362.748 355.139C349.487 351.712 336.512 348.28 324.599 345.166C248.907 325.358 273.486 270.434 291.177 250.754L291.078 250.873Z",
    stroke: "#888888",
    strokeWidth: 0.08,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M507.164 262.746L507.061 262.581C514.156 262.592 527.231 246.598 536.53 228.522C546.331 209.499 585.387 135.285 588.69 128.384C591.992 121.483 593.071 120.81 598.683 122.323L604.295 123.837C604.295 123.837 556.464 270.548 554.229 277.128C553.713 280.274 556.366 281.386 562.146 286.771C560.908 285.987 559.716 285.001 558.572 283.813C547.615 271.976 507.133 262.881 507.133 262.881L507.164 262.746Z",
    stroke: "#797979",
    strokeWidth: 0.08,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M557.049 307.24C556.706 308.722 556.326 310.054 555.874 311.085L711.79 335.424L708.367 332.431L563.021 305.359C561.052 304.974 560.626 300.687 558.445 298.762C558.445 298.762 557.887 303.318 556.982 307.225L557.049 307.24Z",
    fill: "url(#paint95_linear_2825_32890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M555.926 311.167L714.655 336.229L712.459 334.372L561.733 308.467C559.629 308.05 558.284 304.97 558.497 298.844C557.473 307.551 555.858 311.152 555.858 311.152L555.926 311.167Z",
    fill: "url(#paint96_linear_2825_32890)"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M555.46 311.344L712.755 335.861L708.565 332.193L708.498 332.177L563.085 305.09C562.209 304.887 561.65 303.622 560.988 302.191C560.429 300.925 559.767 299.494 558.711 298.54L558.302 298.161L558.177 298.7C558.177 298.7 557.686 303.271 556.78 307.178C556.406 308.795 556.042 310.059 555.606 311.023L555.528 311.36L555.46 311.344ZM710.827 334.988L556.207 310.878C556.56 309.966 556.909 308.769 557.252 307.287C557.97 304.189 558.481 300.758 558.658 299.379C559.394 300.189 559.916 301.303 560.371 302.403C561.085 303.917 561.732 305.415 562.96 305.629L708.238 332.685L710.827 334.988Z",
    fill: "#8E8E8E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M452.663 331.324L530.328 346.904L535.903 342.446L908.801 415.848L919.191 406.543L918.011 411.025L912.462 419.961L882.359 414.478L881.35 418.219L584.632 369.564L563.789 366.084L565.8 359.239L566.131 354.134L541.055 349.318L542.382 355.233L541.789 357.793C541.789 357.793 531.159 356.182 526.617 364.145L528.771 360.669C528.771 360.669 460.194 349.678 449.446 347.047C446.415 346.344 444.669 345.301 443.592 344.129C443.701 343.657 443.904 342.781 445.1 338.232C447.399 329.537 452.611 331.241 452.611 331.241L452.663 331.324Z",
    stroke: "#797979",
    strokeWidth: 0.08,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M408.743 336.765C422.485 322.488 428.142 314.003 446.364 321.135C458.592 325.955 469.808 332.386 475.76 336.108L452.632 331.459C452.632 331.459 447.404 329.822 445.121 338.45C442.823 347.145 444.148 342.342 442.823 347.145C441.58 351.897 442.944 357.04 455.05 358.709C467.223 360.393 480.998 362.52 480.998 362.52L483.508 367.005C482.983 368.658 478.31 378.72 443.427 373.336C422.791 370.187 395.555 363.664 368.764 356.748C387.208 360.169 396.827 348.982 408.691 336.682L408.743 336.765Z",
    stroke: "#D9D9D9",
    strokeWidth: 0.08,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M343.982 346.675C415.269 353.324 407.409 296.563 455.449 315.927C496.52 333.818 524.436 338.937 539.171 340.292C537.132 341.736 535.955 342.528 535.955 342.528L530.38 346.986L475.843 336.055C469.875 332.401 458.675 325.902 446.447 321.081C428.224 313.949 422.568 322.434 408.825 336.712C396.961 349.012 387.342 360.199 368.899 356.778C366.878 356.309 364.872 355.774 362.867 355.238C362.8 355.223 362.732 355.207 362.665 355.191C349.404 351.764 336.429 348.332 324.516 345.217C303.167 339.633 289.838 331.292 282.056 321.681C294.811 333.722 315.604 342.017 344.065 346.623L343.982 346.675Z",
    fill: "url(#paint97_linear_2825_32890)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M291.078 250.873C302.072 238.656 314.057 230.431 331.106 227.921C330.489 228.133 329.805 228.329 328.986 228.495C308.602 233.142 304.918 244.142 316.898 247.273C332.957 251.49 340.222 252.605 359.147 256.706C377.989 260.858 369.608 267.009 397.172 273.039C432.327 280.616 532.149 301.968 544.152 303.471C556.139 305.042 546.209 292.449 555.024 293.923C568.321 296.578 554.42 279.374 522.137 270.12C474.117 256.795 371.158 230.599 371.158 230.599L370.956 230.552C412.118 239.166 506.066 262.28 506.066 262.28C506.403 262.358 506.74 262.436 507.108 262.379L507.211 262.545C507.211 262.545 547.626 271.624 558.651 283.477C559.779 284.732 560.986 285.651 562.224 286.435C563.452 287.571 564.834 288.956 566.388 290.522C575.051 299.699 570.569 310.159 558.529 322.915C546.503 335.603 536.017 342.259 536.017 342.259L530.442 346.717L475.905 335.786C469.937 332.132 458.737 325.633 446.509 320.813C428.287 313.68 422.63 322.165 408.888 336.443C397.024 348.743 387.405 359.93 368.961 356.509C366.94 356.041 364.935 355.505 362.929 354.969C362.862 354.954 362.795 354.938 362.727 354.923C349.467 351.495 336.491 348.063 324.578 344.949C248.887 325.141 273.465 270.217 291.156 250.537L291.078 250.873Z",
    fill: "url(#paint98_linear_2825_32890)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5833 204.071) rotate(-165.336) scale(10.9259 10.9258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.643 265.265) rotate(-165.336) scale(20.1919 20.1919)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.643 265.264) rotate(-165.336) scale(20.1919 20.1919)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.028 232.161) rotate(-165.336) scale(20.1918 20.1919)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.029 232.161) rotate(-165.336) scale(20.1919 20.1919)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(267.188 332.696) rotate(-165.336) scale(32.9156 32.9156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(267.188 332.696) rotate(-165.336) scale(32.9156 32.9156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3961 177.48) rotate(-165.336) scale(15.2131 15.2131)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2825_32890",
    x1: 153.555,
    y1: 245.492,
    x2: 159.685,
    y2: 229.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2825_32890",
    x1: 33.2155,
    y1: 185.554,
    x2: 33.7832,
    y2: 188.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2825_32890",
    x1: 153.555,
    y1: 245.493,
    x2: 158.528,
    y2: 232.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(242.559 295.158) rotate(-165.336) scale(25.309 25.3091)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.539 187.31) rotate(-165.336) scale(3.59555 3.5954)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676767"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3959 177.479) rotate(-165.336) scale(15.2132 15.2131)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(242.559 295.158) rotate(-165.336) scale(25.3091 25.309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(235.244 299.891) rotate(-165.336) scale(34.022 34.022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(235.244 299.892) rotate(-165.336) scale(34.0911 34.0911)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(227.992 292.919) rotate(-165.336) scale(51.8627 51.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(227.991 292.92) rotate(-165.336) scale(51.8627 51.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(215.879 265.805) rotate(-165.336) scale(54.0756 55.1571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(195.354 280.047) rotate(-165.336) scale(50.7564 51.7715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373737"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(215.878 265.805) rotate(-165.336) scale(54.0757 55.1571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(215.222 256.301) rotate(-165.336) scale(11.2715 11.4969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2825_32890",
    x1: 429.558,
    y1: 244.306,
    x2: 411.852,
    y2: 372.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(305.446 274.445) rotate(-165.336) scale(53.9373 53.9373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2825_32890",
    x1: 335.36,
    y1: 253.825,
    x2: 328.591,
    y2: 280.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(436.704 313.152) rotate(-165.336) scale(69.2887 69.2887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2825_32890",
    x1: 315.703,
    y1: 259.831,
    x2: 293.627,
    y2: 254.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2825_32890",
    x1: 341.931,
    y1: 266.408,
    x2: 315.573,
    y2: 259.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2825_32890",
    x1: 360.435,
    y1: 272.18,
    x2: 344.179,
    y2: 267.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2825_32890",
    x1: 371.387,
    y1: 275.402,
    x2: 354.662,
    y2: 271.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2825_32890",
    x1: 399.11,
    y1: 281.567,
    x2: 376.965,
    y2: 280.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2825_32890",
    x1: 393.109,
    y1: 313.396,
    x2: 382.874,
    y2: 310.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2825_32890",
    x1: 406.753,
    y1: 285.014,
    x2: 403.609,
    y2: 284.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2825_32890",
    x1: 411.34,
    y1: 285.786,
    x2: 408.196,
    y2: 284.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2825_32890",
    x1: 415.541,
    y1: 286.671,
    x2: 412.463,
    y2: 285.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2825_32890",
    x1: 419.657,
    y1: 287.605,
    x2: 416.58,
    y2: 286.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2825_32890",
    x1: 423.772,
    y1: 288.539,
    x2: 420.694,
    y2: 287.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2825_32890",
    x1: 428.022,
    y1: 289.508,
    x2: 424.878,
    y2: 288.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2825_32890",
    x1: 432.391,
    y1: 290.294,
    x2: 429.313,
    y2: 289.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2825_32890",
    x1: 436.44,
    y1: 291.211,
    x2: 433.363,
    y2: 290.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2825_32890",
    x1: 440.908,
    y1: 292.166,
    x2: 437.763,
    y2: 291.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2825_32890",
    x1: 444.957,
    y1: 293.082,
    x2: 441.813,
    y2: 292.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2825_32890",
    x1: 449.339,
    y1: 294.085,
    x2: 446.262,
    y2: 293.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2825_32890",
    x1: 453.609,
    y1: 294.703,
    x2: 450.532,
    y2: 293.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2825_32890",
    x1: 459.398,
    y1: 296.075,
    x2: 456.321,
    y2: 295.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2825_32890",
    x1: 465.887,
    y1: 297.773,
    x2: 462.742,
    y2: 296.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2825_32890",
    x1: 470.846,
    y1: 298.212,
    x2: 467.769,
    y2: 297.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2825_32890",
    x1: 475.329,
    y1: 299.385,
    x2: 472.252,
    y2: 298.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2825_32890",
    x1: 478.71,
    y1: 300.128,
    x2: 475.632,
    y2: 299.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2825_32890",
    x1: 483.011,
    y1: 300.896,
    x2: 479.934,
    y2: 300.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2825_32890",
    x1: 486.391,
    y1: 301.638,
    x2: 483.314,
    y2: 300.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2825_32890",
    x1: 490.507,
    y1: 302.571,
    x2: 487.43,
    y2: 301.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2825_32890",
    x1: 494.89,
    y1: 303.574,
    x2: 491.813,
    y2: 302.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2825_32890",
    x1: 499.042,
    y1: 304.375,
    x2: 495.964,
    y2: 303.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2825_32890",
    x1: 502.555,
    y1: 305.153,
    x2: 499.478,
    y2: 304.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2825_32890",
    x1: 507.493,
    y1: 305.943,
    x2: 504.684,
    y2: 305.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2825_32890",
    x1: 510.959,
    y1: 306.636,
    x2: 508.149,
    y2: 305.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2825_32890",
    x1: 514.908,
    y1: 307.383,
    x2: 512.098,
    y2: 306.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2825_32890",
    x1: 518.62,
    y1: 308.497,
    x2: 515.81,
    y2: 307.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2825_32890",
    x1: 521.866,
    y1: 309.205,
    x2: 518.99,
    y2: 308.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2825_32890",
    x1: 525.382,
    y1: 309.696,
    x2: 522.573,
    y2: 308.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2825_32890",
    x1: 529.231,
    y1: 310.559,
    x2: 526.355,
    y2: 309.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2825_32890",
    x1: 533.215,
    y1: 311.173,
    x2: 530.406,
    y2: 310.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2825_32890",
    x1: 536.463,
    y1: 311.88,
    x2: 533.653,
    y2: 311.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2825_32890",
    x1: 540.011,
    y1: 312.523,
    x2: 537.201,
    y2: 311.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2825_32890",
    x1: 465.859,
    y1: 300.61,
    x2: 460.478,
    y2: 300.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(437.195 317.283) rotate(-165.336) scale(69.2887 69.2886)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(437.195 317.283) rotate(-165.336) scale(69.2887 69.2887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2825_32890",
    x1: 539.493,
    y1: 185.299,
    x2: 586.899,
    y2: 207.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2825_32890",
    x1: 539.493,
    y1: 185.298,
    x2: 586.898,
    y2: 207.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2825_32890",
    x1: 539.493,
    y1: 185.297,
    x2: 586.899,
    y2: 207.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(908.461 429.521) rotate(-165.336) scale(11.1332 11.1332)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(759.202 421.916) rotate(-165.336) scale(29.873 29.8729)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(759.202 421.916) rotate(-165.336) scale(29.873 29.8729)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(652.213 401.925) rotate(-165.336) scale(30.4261 30.4261)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(652.213 401.924) rotate(-165.336) scale(30.4262 30.4262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(581.593 388.805) rotate(-165.336) scale(33.123 33.123)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(581.593 388.805) rotate(-165.336) scale(33.123 33.123)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(581.611 388.738) rotate(-165.336) scale(33.123 33.123)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(481.649 345.713) rotate(-165.336) scale(55.5969 55.5969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(489.144 307.7) rotate(-176.036) scale(79.1772 79.1772)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2825_32890",
    x1: 679.611,
    y1: 385.599,
    x2: 682.966,
    y2: 366.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2825_32890",
    x1: 676.045,
    y1: 385.021,
    x2: 679.4,
    y2: 365.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2825_32890",
    x1: 911.867,
    y1: 426.338,
    x2: 915.213,
    y2: 407.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(536.545 391.6) rotate(-165.336) scale(52.8309 52.8309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(536.545 391.601) rotate(-165.336) scale(52.8309 52.8308)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(539.731 381.067) rotate(-165.336) scale(34.0911 34.0911)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(539.731 381.066) rotate(-165.336) scale(34.0911 34.0911)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(532.495 374.028) rotate(-165.336) scale(51.8627 51.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(532.495 374.029) rotate(-165.336) scale(51.8627 51.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(520.293 346.991) rotate(-165.336) scale(54.0755 55.1571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(499.853 361.182) rotate(-165.336) scale(50.7563 51.7715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373737"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(520.359 347.009) rotate(-165.336) scale(54.0756 55.1571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_2825_32890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(519.72 337.437) rotate(-165.336) scale(11.2715 11.497)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2825_32890",
    x1: 636.925,
    y1: 307.647,
    x2: 634.21,
    y2: 324.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2825_32890",
    x1: 639.541,
    y1: 306.115,
    x2: 635.726,
    y2: 323.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2825_32890",
    x1: 423.144,
    y1: 243.414,
    x2: 405.505,
    y2: 371.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2825_32890",
    x1: 440.703,
    y1: 225.207,
    x2: 412.746,
    y2: 332.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8A8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.95dfd2f32075266f607c8e8f84eaeb5c.svg";
export { ForwardRef as ReactComponent };